import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { fetcher } from "../../_helpers/fetcher";
import { history } from "../../_helpers/history";

const baseUrl = `${process.env.REACT_APP_BASE_URL}`;
const name = "auth";

// thunk
export const loginAdmin = createAsyncThunk(
  `${name}/login`,
  async ({ email, password }) =>
    await fetch(
      `${process.env.REACT_APP_BASE_URL}/admin/auth/login`,
      {
        method: 'POST',
        headers: {
          'Content-type': "application/json",
        },
        body: JSON.stringify({ email: email, password: password }),
      }
    )
      .then((data) => data.json())
      .then(data => {
        console.log(data.data)
        return data.data
      })
      .catch((error) => console.log(error))
);
  
  // create slice
  const initialState = {
    user: {},
    error: null,
    loading: false
  };
  

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logoutAdmin(state, action) {
      state.user = null
      localStorage.removeItem("afcfta-user")
      sessionStorage.removeItem("afcfta-user")
      window.location.replace("/")
    },
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loginAdmin.pending, (state) => {
      state.error = null;
      state.loading = true
    });
    builder.addCase(loginAdmin.fulfilled, (state, action) => {
      const user = action.payload;
      console.log("User payload", user)
      
      sessionStorage.setItem("afcfta-user", (user.token));
      state.user = user;
      window.location.replace("/dashboard")
      state.loading = false
    });
    builder.addCase(loginAdmin.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false
    })
  }
})


export const {logoutAdmin, startLoading, stopLoading} = authSlice.actions
export const authReducer = authSlice.reducer


// export const authSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     logout(state, action) {
//       state.user = null;
//       localStorage.removeItem("afcfta-user");
//       history.navigate("/");
//     },
//     loginError(state, action) {
//       state.error = action.payload
//     }
//   },
//   extraReducers: (builder) => {
    // builder.addCase(loginAdmin.pending, (state) => {
    //   state.error = null;
    // });
    // builder.addCase(loginAdmin.fulfilled, (state, action) => {
    //   const user = action.payload;
    //   // store user details and jwt token in local storage
    //   localStorage.setItem("afcfta-user", JSON.stringify(user));
    //   state.user = user;

    //   const { from } = history.location.state || {
    //     from: { pathname: "/" },
    //   };
    //   history.navigate(from);
    // });
    // builder.addCase(loginAdmin.rejected, (state, action) => {
    //   state.error = action.error;
    // });
//   },
// }).reducer


// exports

// export const authActions = {...authSlice.actions, ...loginAdmin}
// export const authReducer = authSlice.reducer;
